<template>
  <el-select class="inputWidth" v-bind="$attrs" @change="change" clearable>
    <el-option
      v-for="(item, index) in renderOptions"
      :key="index"
      :value="item.value"
      :label="item.label"
    >
    </el-option>
  </el-select>
</template>

<script>
  import { mapEnumList } from '@/common/js/enums';
  export default {
    /**
     * 可以传对象也可以传数组
     */
    props: {
      options: {
        type: [Object, Array],
        default: () => {},
      },
    },
    data() {
      return {};
    },
    computed: {
      renderOptions() {
        return Array.isArray(this.options) ? this.options : mapEnumList(this.options);
      },
    },
    methods: {
      change(value) {
        this.$emit('input', value);
      },
    },
  };
</script>
